export default "__VITE_ASSET__GrmAGcFg__"